import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import classNames from 'classnames';
import { IntlProvider } from 'react-intl';

import withNormalizedRouter from '../../hocs/normalizedRouter';
import LocaleContext from '../../hocs/LocaleContext';
import { NotificationStorageProvider } from '../../hocs/NotificationStorage';
import Version from '../../components/Version';

import Category from '../../pages/Category';
import TopNotification from '../../pages/Category/component/TopNotification';

import styles from './index.scss';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            catalogs: {},
            notification: {
                type: '',
                message: '',
            },
        };
    }

    updateNotificationState = ({ type, message }) => {
        this.setState({
            notification: {
                ...this.state.notification,
                message,
                type,
            },
        });
    };

    render() {
        const {
            match: {
                url,
                params: { cc, lc },
            },
        } = this.props;

        const { catalogs } = this.state;

        const baseUrl = url.replace(/\/$/, '');
        const localeContextValue = { cc, lc };

        const topContainerClass = classNames({
            [styles.appOuter]: true,
            apcComparison: false,
        });

        // if (!catalogs[lc]) {
        //     return <Loader />;
        // }

        return (
            <IntlProvider locale={lc} messages={catalogs[lc]}>
                <LocaleContext.Provider value={localeContextValue}>
                    <NotificationStorageProvider>
                        <div className={topContainerClass}>
                            <React.Fragment>
                                <TopNotification closeHandler={this.updateNotificationState} />
                                <div className={styles.selectorsApp}>
                                    <Switch>
                                        <Route exact path={`${baseUrl}`} component={Category} />
                                        <Route
                                            exact
                                            path={`${baseUrl}/N-:id`}
                                            component={Category}
                                        />
                                        <Route
                                            exact
                                            path={`${baseUrl}/:supercat/N-:id`}
                                            component={Category}
                                        />
                                        <Route
                                            exact
                                            path={`${baseUrl}/:supercat/:cat/N-:id`}
                                            component={Category}
                                        />
                                        <Route
                                            exact
                                            path={`${baseUrl}/:supercat/:cat/:subcat/N-:id`}
                                            component={Category}
                                        />
                                        <Route
                                            exact
                                            path={`${baseUrl}/:supercat/:cat/:subcat/:secsubcat/N-:id`}
                                            component={Category}
                                        />
                                        <Route
                                            exact
                                            path={`${baseUrl}/:supercat/:cat/:subcat/:secsubcat/_/N-:id`}
                                            component={Category}
                                        />
                                        <Route component={Category} />
                                    </Switch>
                                </div>
                                <Version />
                            </React.Fragment>
                            {/* {loading ? <Loader /> : null} */}
                        </div>
                    </NotificationStorageProvider>
                </LocaleContext.Provider>
            </IntlProvider>
        );
    }
}

App.propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default withNormalizedRouter(App);
